module.exports = __webpack_public_path__ + "icon-Pando-outlines.6bc64b7329e8348f761f.svg";